import Layout from '../components/Layout';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useState } from 'react';
import { toast } from '../hooks/use-toast';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: 'Please fill all fields' });
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast({ title: 'Message sent!', description: 'We usually reply within 6 hours.' });
      setForm({ name: '', email: '', message: '' });
    } catch (e) {
      toast({ title: 'Failed to send', description: e.response?.data?.detail || 'Try again.' });
    } finally { setSending(false); }
  };

  return (
    <Layout>
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-12">
          <div>
            <p className="eyebrow mb-4">Contact</p>
            <h1 className="h-display text-4xl md:text-5xl">We&apos;re here to <em className="font-serif-display italic font-normal text-navy">help.</em></h1>
            <p className="mt-4 text-neutral-600">Questions about your tag, order or partnership? Reach out and we&apos;ll get back within 6 hours.</p>

            <div className="mt-8 space-y-4">
              <div className="flex gap-3 items-start">
                <div className="w-10 h-10 rounded-lg bg-navy text-white flex items-center justify-center"><Mail size={16} /></div>
                <div><p className="text-sm font-semibold">Email</p><p className="text-sm text-neutral-600">connectnearme1@gmail.com</p></div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="w-10 h-10 rounded-lg bg-navy text-white flex items-center justify-center"><Phone size={16} /></div>
                <div>
                  <p className="text-sm font-semibold">Support</p>
                  <a href="tel:+919228143222" className="text-sm text-neutral-600 hover:text-navy" data-testid="contact-support-phone">+91 92281 43222</a>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <div className="w-10 h-10 rounded-lg bg-navy text-white flex items-center justify-center"><MapPin size={16} /></div>
                <div>
                  <p className="text-sm font-semibold">Vadodara Office</p>
                  <p className="text-sm text-neutral-600 leading-relaxed" data-testid="contact-vadodara-address">
                    1st Floor, Plot No. 9, Nr. One Stop Carz,<br />
                    Opp. Welcare Hospital, Atladara,<br />
                    Vadodara, Gujarat &ndash; 390012
                  </p>
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="card-soft p-8 space-y-4">
            <div>
              <label className="text-sm font-medium">Name</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 w-full px-4 py-2.5 rounded-lg border border-black/15 bg-white focus:outline-none focus:ring-2 focus:ring-navy/30" placeholder="Ravi Kumar" />
            </div>
            <div>
              <label className="text-sm font-medium">Email</label>
              <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} type="email" className="mt-1 w-full px-4 py-2.5 rounded-lg border border-black/15 bg-white focus:outline-none focus:ring-2 focus:ring-navy/30" placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-sm font-medium">Message</label>
              <textarea rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1 w-full px-4 py-2.5 rounded-lg border border-black/15 bg-white focus:outline-none focus:ring-2 focus:ring-navy/30 resize-none" placeholder="How can we help?" />
            </div>
            <button disabled={sending} type="submit" className="btn-primary w-full justify-center disabled:opacity-60">{sending ? 'Sending...' : 'Send message'}</button>
          </form>
        </div>
      </section>
    </Layout>
  );
}
